import BaseCustomFieldDefinitionDto from '@/features/dashboard/tourCustomFields/types/BaseCustomFieldDefinitionDto.ts';
import { TargetType } from '@/types/TargetType.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { CustomFieldFormData } from '@/features/dashboard/tourCustomFields/schemas/_customFieldSchema.ts';
import CustomFieldDefinitionDto from '@/features/dashboard/tourCustomFields/types/_CustomFieldDefinitionDto.ts';
import { DropdownCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/DropdownCustomFieldDefinitionDto.ts';
import { TextCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/TextCustomFieldDefinitionDto.ts';
import { LongTextCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/LongTextCustomFieldDefinitionDto.ts';
import { CheckboxCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/CheckboxCustomFieldDefinitionDto.ts';

export const customFieldDefinitionMapper = {
  fromFormToDto: (
    fieldDef: CustomFieldFormData,
  ): Omit<CustomFieldDefinitionDto, 'id' | 'orderIndex'> => {
    const baseDto: Omit<BaseCustomFieldDefinitionDto, 'id' | 'orderIndex'> = {
      name: fieldDef.fieldName,
      targetType: TargetType.PARTICIPANT,
      required: fieldDef.isFieldMandatory,
      // scope: FieldScopeDto | null; // for now we don't need scope
      hint: fieldDef.hint,
      type: fieldDef.type,
    };

    switch (fieldDef.type) {
      case FieldType.TEXT: {
        const result: Omit<TextCustomFieldDefinitionDto, 'id' | 'orderIndex'> =
          {
            ...baseDto,
            type: FieldType.TEXT,
            minChars: fieldDef.minChars,
            maxChars: fieldDef.maxChars,
            placeholder: fieldDef.placeholder,
          };
        return result;
      }
      case FieldType.LONG_TEXT: {
        const result: Omit<
          LongTextCustomFieldDefinitionDto,
          'id' | 'orderIndex'
        > = {
          ...baseDto,
          type: FieldType.LONG_TEXT,
          minChars: fieldDef.minChars,
          maxChars: fieldDef.maxChars,
          placeholder: fieldDef.placeholder,
          defaultHeight: fieldDef.rowsNumber,
        };
        return result;
      }
      case FieldType.CHECKBOX: {
        const result: Omit<
          CheckboxCustomFieldDefinitionDto,
          'id' | 'orderIndex'
        > = {
          ...baseDto,
          type: FieldType.CHECKBOX,
          defaultValue: fieldDef.defaultValue,
        };
        return result;
      }
      case FieldType.DROPDOWN: {
        const result: Omit<
          DropdownCustomFieldDefinitionDto,
          'id' | 'orderIndex'
        > = {
          ...baseDto,
          type: FieldType.DROPDOWN,
          placeholder: fieldDef.placeholder,
          options: fieldDef.options.map((option) => ({
            label: option.label,
          })),
        };
        return result;
      }
    }
  },
};
